import type { ArticleType } from '@/types/ArticleType';
import mapWpPosts from '@/utils/functions/wordpress/mapWpPosts';
import wpApi from '@/utils/functions/wordpress/wpApi';

type FetchPostsOptionsFilter = {
    categories?: number[]; // array of category ids
    tags?: number[]; // array of tag ids
    author?: number; // user id
    postType?: string; // post type (e.g. event, post, webinar, speaker);
};

type FetchPostsOptionsOrder = {
    orderBy: 'date';
    direction: 'desc' | 'asc';
};

type FetchPostsOptions = {
    filter?: FetchPostsOptionsFilter;
    order?: FetchPostsOptionsOrder;
    limit: number;
    page?: number;
};

const fetchPosts = async (
    options: FetchPostsOptions = { limit: 12, page: 1, order: { orderBy: 'date', direction: 'desc' } }
): Promise<ArticleType[]> => {
    const { limit, order, filter, page } = options;
    let wpPosts = wpApi().posts();

    if (filter?.categories) {
        if (filter.categories?.length > 0) {
            wpPosts = wpPosts.categories(filter.categories!);
        }
    }

    if (filter?.tags) {
        if (filter.tags?.length > 0) {
            wpPosts = wpPosts.tags(filter.tags!.join(','));
        }
    }

    if (filter?.author) {
        if (filter.author >= 0) {
            wpPosts = wpPosts.author(filter.author!);
        }
    }

    if (filter?.postType) {
        wpPosts = wpPosts.type(filter.postType!);
    }

    if (order !== null) {
        wpPosts = wpPosts.orderby(order?.orderBy ?? 'date').order(order?.direction ?? 'desc');
    }

    const result = await wpPosts
        .perPage(limit)
        .page(page || 1)
        .embed()
        .get();

    return mapWpPosts(result);
};

export default fetchPosts;
